type ErrorLike = {
  message?: unknown;
  detail?: unknown;
  error?: unknown;
};

const pickMessage = (value: unknown): string | null => {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed || null;
  }

  if (!value || typeof value !== "object") {
    return null;
  }

  const record = value as Record<string, unknown>;

  return (
    pickMessage(record.message) ||
    pickMessage(record.detail) ||
    pickMessage(record.error) ||
    pickMessage(record.summary) ||
    null
  );
};

export const getErrorMessage = (error: unknown, fallback: string): string => {
  return pickMessage(error as ErrorLike) || fallback;
};
